import { Fragment } from "react";
import { Check, Minus } from "lucide-react";
import { TIERS, FEATURE_GROUPS } from "@/lib/plan-features";

function Cell({ value }) {
  if (value === true) {
    return <Check className="w-4 h-4 mx-auto text-emerald-700" strokeWidth={2.5} data-testid="cell-yes" />;
  }
  if (value === false) {
    return <Minus className="w-4 h-4 mx-auto text-foreground/30" strokeWidth={2} data-testid="cell-no" />;
  }
  return <span className="font-mono-data text-sm" data-testid="cell-text">{value}</span>;
}

export default function ComparisonMatrix() {
  return (
    <div className="overflow-x-auto border border-foreground" data-testid="comparison-matrix">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-foreground">
            <th className="text-left p-4 align-bottom font-mono-data text-[10px] uppercase tracking-widest text-muted-foreground w-[34%]">
              feature
            </th>
            {TIERS.map((t) => (
              <th
                key={t.id}
                className={`text-center p-4 align-bottom ${t.popular ? "bg-foreground text-background" : ""}`}
                data-testid={`matrix-tier-${t.id}`}
              >
                <div className="font-semibold tracking-tight text-base">{t.label}</div>
                <div className="mt-0.5">
                  <span className="font-semibold tracking-tight text-2xl">{t.price}</span>
                  <span className={`text-xs ml-1 ${t.popular ? "text-background/80" : "text-muted-foreground"}`}>{t.sub}</span>
                </div>
                {t.popular && (
                  <div className="mt-1 font-mono-data text-[9px] uppercase tracking-widest opacity-80">
                    most popular
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {FEATURE_GROUPS.map((g) => (
            <Fragment key={g.name}>
              <tr className="bg-secondary/40 border-b border-foreground/10">
                <td colSpan={TIERS.length + 1} className="px-4 py-2.5 font-mono-data text-[10px] uppercase tracking-widest text-muted-foreground">
                  // {g.name.toLowerCase()}
                </td>
              </tr>
              {g.rows.map(([label, values]) => (
                <tr key={label} className="border-b border-foreground/10 last:border-0 hover:bg-secondary/20">
                  <td className="p-3 font-medium">{label}</td>
                  {TIERS.map((t) => (
                    <td key={t.id} className={`p-3 text-center ${t.popular ? "bg-foreground/5" : ""}`}>
                      <Cell value={values[t.id]} />
                    </td>
                  ))}
                </tr>
              ))}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
